export default __webpack_public_path__ + "images/SpeakersPhotos/Fernando.jpg?ef107e31";